// extracted by mini-css-extract-plugin
export default {"label":"PageName_label__oI34U"};